import { connect } from 'react-redux'
import actions from 'store/sites/actions'
import SiteSearch from './SiteSearch'

const mapDispatchToProps = dispatch => ({
  searchSites: (params) => {
    if (params.code || params.query.length > 0) {
      dispatch({ type: actions.fetchSites, params })
    } else {
      dispatch({ type: actions.resetSites })
    }
  }
})

export default connect(null, mapDispatchToProps)(SiteSearch)



// WEBPACK FOOTER //
// ./src/components/SiteSearch/index.js